import React from "react";
import { Typography, Flex, Avatar, Button } from "../../../components";

interface AvatarUploaderProps {
  avatarUrl?: string;
  onUpload: () => void;
}

export const AvatarUploader: React.FC<AvatarUploaderProps> = ({ avatarUrl, onUpload }) => {
  return (
    <Flex direction="column" align="center" gap="sm">
      <Avatar size="lg" src={avatarUrl} name="User Avatar" />
      <Button size="compact" variant="outline" onClick={onUpload}>
        Upload New Photo
      </Button>
    </Flex>
  );
};